import { CallForwardingSearchDto } from '../../models/call-forwarding-dto';

export const FETCH_CALL_FORWARDING = 'callForwarding/FETCH_CALL_FORWARDING';
export const FETCH_CALL_FORWARDING_SUCCESS = 'callForwarding/FETCH_CALL_FORWARDING_SUCCESS';
export const FETCH_CALL_FORWARDING_FAILED = 'callForwarding/FETCH_CALL_FORWARDING_FAILED';
export const SET_SEARCH_CALL_FORWARDING = 'callForwarding/SET_SEARCH_CALL_FORWARDING';
export const EXPORT_CALL_FORWARDING = 'callForwarding/EXPORT_CALL_FORWARDING';
export const EXPORT_CALL_FORWARDING_SUCCESS = 'callForwarding/EXPORT_CALL_FORWARDING_SUCCESS';
export const EXPORT_CALL_FORWARDING_FAILED = 'callForwarding/EXPORT_CALL_FORWARDING_FAILED';
export const CANCEL_CALL_FORWARDING = 'callForwarding/CANCEL_CALL_FORWARDING';
export const CANCEL_CALL_FORWARDING_SUCCESS = 'callForwarding/CANCEL_CALL_FORWARDING_SUCCESS';
export const CANCEL_CALL_FORWARDING_FAILED = 'callForwarding/CANCEL_CALL_FORWARDING_FAILED';

export const fetchCallForwarding = (payload: any = {}) => ({
  type: FETCH_CALL_FORWARDING,
  payload,
});

export const fetchCallForwardingSuccess = (payload: any) => ({
  type: FETCH_CALL_FORWARDING_SUCCESS,
  payload,
});

export const fetchCallForwardingFailed = (payload: any) => ({
  type: FETCH_CALL_FORWARDING_FAILED,
  payload,
});

export const setSearchCallForwarding = (payload: Partial<CallForwardingSearchDto>) => ({
  type: SET_SEARCH_CALL_FORWARDING,
  payload,
});

export const exportCallForwarding = (payload: any) => ({
  type: EXPORT_CALL_FORWARDING,
  payload,
});

export const exportCallForwardingSuccess = () => ({
  type: EXPORT_CALL_FORWARDING_SUCCESS,
});

export const exportCallForwardingFailed = (payload: any) => ({
  type: EXPORT_CALL_FORWARDING_FAILED,
  payload,
});

export const cancelCallForwarding = (requestId: number, cancellationReason?: string, searchPayload?: any) => ({
  type: CANCEL_CALL_FORWARDING,
  payload: { requestId, cancellationReason, searchPayload },
});

export const cancelCallForwardingSuccess = () => ({
  type: CANCEL_CALL_FORWARDING_SUCCESS,
});

export const cancelCallForwardingFailed = (payload: any) => ({
  type: CANCEL_CALL_FORWARDING_FAILED,
  payload,
});
